import StepCard from "./components/StepCard";
import memberImg from "../../../assets/img/apponboarding/member.png";

const StepAddEmployees = ({ onCtaClick, onSkip, isCtaLoading, stepNumber, totalSteps, selectedOrganization }) => {
  const isOperation = selectedOrganization?.type === "operation";
  return (
  <StepCard
    stepLabel={`Step ${stepNumber}`}
    title="Add Your Employee"
    description={`Invite your technicians so they can receive ${isOperation ? "tasks" : "jobs"} and update progress from the mobile app.`}
    ctaLabel="Invite Members"
    onCtaClick={onCtaClick}
    onSkip={onSkip}
    isCtaLoading={isCtaLoading}
    mediaSrc={null}
    selectedOrganization={selectedOrganization}
    backgroundColor="#EDF8FE"
    backgroundImage={memberImg}
    videoUrl="https://youtu.be/x9YsnYAr_LE"
  />
  );
};

export default StepAddEmployees;
